import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = ({ setView, currentView }) => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleViewChange = (e, newView, data = null) => {
    e.preventDefault();
    setIsMenuOpen(false); // Close mobile menu on click

    if (newView === 'industry-detail' || newView === 'service-detail') {
      setView(newView, data);
    } else {
      setView(newView);
      if (data && typeof data === 'string' && data.startsWith('#')) {
        setTimeout(() => {
          const element = document.querySelector(data);
          if (element) {
            const offset = 80; // Account for fixed navbar
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
          }
        }, 200);
      } else {
        window.scrollTo(0, 0);
      }
    }
  };

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="navbar-container">

        {/* Logo Section */}
        <a
          href="#home"
          className="navbar-logo"
          onClick={(e) => handleViewChange(e, 'home')}
        >
          <img src="/images/logo.png" alt="cabptoid logo" className="logo-img" />
          <span className="logo-text">cabptoid</span>
        </a>

        {/* Mobile Toggle Button */}
        <button className={`mobile-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Toggle Menu">
           <span className="bar bar-1"></span>
           <span className="bar bar-2"></span>
           <span className="bar bar-3"></span>
        </button>

        {/* Navigation Links */}
        <nav className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
          <a
            href="#portfolio"
            className={`nav-link ${currentView === 'portfolio' ? 'active' : ''}`}
            onClick={(e) => handleViewChange(e, 'portfolio')}
          >
            <span className="nav-text" data-text="PORTFOLIO"><span>PORTFOLIO</span></span>
          </a>

          <div className="nav-item-dropdown">
            <a
              href="#services"
              className="nav-link"
              onClick={(e) => {
                if (window.innerWidth <= 968) {
                  // On mobile, clicking the toggle link can toggle the dropdown visibility if we want, 
                  // but for now let's just allow navigation if clicked.
                  // handleViewChange(e, 'home', '#services');
                } else {
                  handleViewChange(e, 'home', '#services');
                }
              }}
            >
              <span className="nav-text" data-text="SERVICES"><span>SERVICES</span></span>
              <span className="dropdown-icon">▼</span>
            </a>
            <ul className="dropdown-menu">
              <li><a href="#services" onClick={(e) => handleViewChange(e, 'service-detail', 'Performance Marketing')}>Performance Marketing</a></li>
              <li><a href="#services" onClick={(e) => handleViewChange(e, 'service-detail', 'Influencer Marketing')}>Influencer Marketing</a></li>
              <li><a href="#services" onClick={(e) => handleViewChange(e, 'service-detail', 'Celebrity & Influencer Marketing')}>Celebrity Marketing</a></li>
              <li><a href="#services" onClick={(e) => handleViewChange(e, 'service-detail', 'Social Media Management')}>Social Media Mgmt</a></li>
              <li><a href="#services" onClick={(e) => handleViewChange(e, 'service-detail', 'SEO Mastery')}>SEO Mastery</a></li>
              <li><a href="#services" onClick={(e) => handleViewChange(e, 'service-detail', 'Brand Marketing')}>Brand Marketing</a></li>
            </ul>
          </div>

          <div className="nav-item-dropdown">
            <a href="#industries" className="nav-link" onClick={(e) => e.preventDefault()}>
              <span className="nav-text" data-text="INDUSTRIES"><span>INDUSTRIES</span></span>
              <span className="dropdown-icon">▼</span>
            </a>
            <ul className="dropdown-menu">
              <li><a href="#tech" onClick={(e) => handleViewChange(e, 'industry-detail', 'Technology')}>Technology & SaaS</a></li>
              <li><a href="#healthcare" onClick={(e) => handleViewChange(e, 'industry-detail', 'Healthcare')}>Healthcare & Wellness</a></li>
              <li><a href="#ecommerce" onClick={(e) => handleViewChange(e, 'industry-detail', 'E-commerce')}>Retail & E-commerce</a></li>
              <li><a href="#realestate" onClick={(e) => handleViewChange(e, 'industry-detail', 'Real Estate')}>Real Estate & Construction</a></li>
              <li><a href="#education" onClick={(e) => handleViewChange(e, 'industry-detail', 'Education')}>Education & E-learning</a></li>
            </ul>
          </div>

          <a
            href="#about"
            className="nav-link"
            onClick={(e) => handleViewChange(e, 'about')}
          >
            <span className="nav-text" data-text="ABOUT US"><span>ABOUT US</span></span>
            <span className="dropdown-icon">▼</span>
          </a>

          <a
            href="#insights"
            className="nav-link"
            onClick={(e) => handleViewChange(e, 'insights')}
          >
            <span className="nav-text" data-text="INSIGHTS"><span>INSIGHTS</span></span>
          </a>

          {/* CTA included inside the links for mobile view */}
          <div className="navbar-cta-mobile">
            <a
              href="#contact"
              className="btn-get-in-touch"
              data-text="Get in Touch"
              onClick={(e) => handleViewChange(e, 'home', '#contact')}
            >
              <span>Get in Touch</span>
            </a>
          </div>
        </nav>

        {/* Call to Action Button (Desktop only) */}
        <div className="navbar-cta">
          <a
            href="#contact"
            className="btn-get-in-touch"
            data-text="Get in Touch"
            onClick={(e) => handleViewChange(e, 'home', '#contact')}
          >
            <span>Get in Touch</span>
          </a>
        </div>

      </div>
    </header>
  );
};

export default Navbar;
